import React, {useState} from "react";
import PropTypes from "prop-types";
import {compose} from "recompose";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import Actions from "../../../../store/actions/index";
import {withStyles, Typography} from "@material-ui/core";
import InsertInvitationIcon from '@material-ui/icons/InsertInvitation';
import t from "../../../../languages/pl";
import useStyles from "./buttonGroupStyle";
import Zoning from "./CarSettings/Zoning";
import RentingList from "./CarRenting/RentingList";
import withSubordinateUser from './../../../HOC/withSubordinateUser';
import ReservationDialog from './CarRenting/ReservationDialogComponent/ReservationDialog';
import ConfirmationDialog from "../../../Common/ConfirmationDialog";
import {useEffect} from "react";
import CarEvidences from "./CarSettings/CarEvidences";
import CarParameters from "./CarSettings/CarParameters";
import CarPricing from "./CarSettings/CarPricing/CarPricing";

const CarSettings = props => {
    const {
        classes,
        carId,
        registrationNo,
        zones,
        rentList,
        nonAdminUser,
        carType
    } = props;
    const [rents, setRents] = useState([]);
    const [isDialogOpen, setDialog] = useState(false);
    const [rentType, setRentType] = useState(null);
    const [idToDelete, setIdToDelete] = useState(null);

    useEffect(() => {
        setRents(rentList);
    }, [rentList]);

    const handleZoneClick = () => {
        props.getPoolZones(carId);
    };

    const handleZoneSubmit = (zones, assignIds) => {
        let carIds = [carId, ...assignIds];
        props.patchPoolZones(carIds, zones);
    };

    const handleRentListOpen = () => {
        props.getRentList(carId);
    };

    const handleDefaultZone = () => {
        props.clearZones();
        props.getPoolZones(carId, true);
    };

    const handleRentTypeOpen = (rent_id, type) => {
        setRentType(type);
        setDialog(true);
    };

    const handlePutPoolAndCloseDialog = (carId, rentId, data) => {
        props.putPool(carId, rentId, data);
        setDialog(false);
    };

    const handlePutRentAndCloseDialog = (carId, rentId, data) => {
        props.putRent(carId, rentId, data);
        setDialog(false);
    };

    const handlePutPool = (carId, rentId, data) => {
        props.putPool(carId, rentId, data);
    };

    const handlePutRent = (carId, rentId, data) => {
        props.putRent(carId, rentId, data);
    };

    const handleAddPool = (data) => {
        props.addPool(carId, data);
    };

    const handleAddRent = (data) => {
        props.addRent(carId, data);
    };

    const handleSetCarEvidencePeriod = (data) => {
        console.log("carId, data", carId, data);
    };

    const handleDeletePool = (rentId) => {
        setIdToDelete(rentId);
    };

    const handleDeleteRent = (rentId) => {
        setIdToDelete(rentId);
    };

    const handleConfirmDelete = (rentId) => {
        if (rentType === "Pool") {
            props.deletePool(carId, rentId);
        } else {
            props.deleteRent(carId, rentId);
        }
        setDialog(false);
    };

    const handleCloseDialog = () => {
        setDialog(false);
    };

    const handleDateChange = (type, value, rentId) => {
        props.putRentDate(carId, rentId, type, value);
    };

    const handleChangeSelectedPricing = (selectedPricing) => {
        props.updateCarPricing(carId, selectedPricing);
    };

    return (
        <div className={classes.container}>
            <div className={classes.header}>
                <InsertInvitationIcon style={{marginRight: 5}}/>
                <Typography variant="body1">Wynajmowanie i zarządzanie pool</Typography>
            </div>
            <div className={classes.content}>
                <Zoning
                    buttonTitle={t.zoningWhileLending}
                    title={t.zoningWhileLending}
                    name={registrationNo}
                    carType={carType}
                    zones={zones.lista_rejon}
                    carCoords={zones.pozycja}
                    dialogOpenCallback={handleZoneClick}
                    onSubmit={handleZoneSubmit}
                    onCancel={() => props.clearZones()}
                    onDefaultZone={handleDefaultZone}
                />
                {
                    !nonAdminUser
                    &&
                    <RentingList
                        name={registrationNo}
                        rents={rents}
                        dialogOpenCallback={handleRentListOpen}
                        carId={carId}
                        onDialogOpenCallback={(rent_id, type) => handleRentTypeOpen(rent_id, type)}
                        onAddPool={handleAddPool}
                        onAddRent={handleAddRent}
                        onDateChange={handleDateChange}
                    />
                }
                {
                    !nonAdminUser
                    &&
                    <CarEvidences
                        name={registrationNo}
                        autoId={carId}
                        onDialogOpen={() => props.getCarEvidence(carId)}
                        onSubmit={handleSetCarEvidencePeriod}
                    />
                }
                {
                    !nonAdminUser
                    &&
                    <CarPricing
                        name={registrationNo}
                        autoId={carId}
                        onDialogOpen={() => props.getCarPricing(carId)}
                        onSubmit={handleChangeSelectedPricing}
                    />
                }
            </div>
            <ReservationDialog
                isDialogOpen={isDialogOpen}
                closeDialog={handleCloseDialog}
                rentType={rentType}
                isEdit={true}
                carId={carId}
                onDeletePool={handleDeletePool}
                onDeleteRent={handleDeleteRent}
                onPutPoolAndClose={handlePutPoolAndCloseDialog}
                onPutRentAndClose={handlePutRentAndCloseDialog}
                onPutPool={handlePutPool}
                onPutRent={handlePutRent}
                cars={[]}
            />
            <ConfirmationDialog
                open={idToDelete !== null}
                onClose={() => setIdToDelete(null)}
                onSubmit={handleConfirmDelete}
                id={idToDelete}
                action={rentType === "Pool" ? t.deletePoolConfirmation : t.deleteRentConfirmation}
            />
        </div>
    );
};

const mapStateToProps = (state) => ({
    zones: state.carsReducer.zones,
    rentList: state.carsReducer.rentList,
    carParameters: state.carsReducer.carParameters,
    possibleParameters: state.carsReducer.possibleCarParameters
});

const mapDispatchToProps = dispatch => {
    return bindActionCreators(Actions, dispatch);
};

export default compose(
    withStyles(useStyles),
    connect(
        mapStateToProps,
        mapDispatchToProps
    ),
    withSubordinateUser
)(CarSettings);

CarSettings.propTypes = {
    classes: PropTypes.object,
    carId: PropTypes.number,
    registrationNo: PropTypes.string,
    carType: PropTypes.string,
    getCarEvidence: PropTypes.func,
    getCarPricing: PropTypes.func,
    updateCarPricing: PropTypes.func,
    //redux
    zones: PropTypes.object,
    rentList: PropTypes.array,
    getPoolZones: PropTypes.func,
    clearZones: PropTypes.func,
    patchPoolZones: PropTypes.func,
    getRentList: PropTypes.func,
    getRent: PropTypes.func,
    addPool: PropTypes.func,
    addRent: PropTypes.func,
    putPool: PropTypes.func,
    putRent: PropTypes.func,
    deletePool: PropTypes.func,
    deleteRent: PropTypes.func,
    putRentDate: PropTypes.func,
    //withSubordinateUser
    nonAdminUser: PropTypes.bool
};
